import colors from '../../../../../public/colors'


/* eslint-disable */

const styles = theme => {
    const { mode } = theme.palette
    return {
    actionRow: {
        '& > button': {
            marginLeft: 'auto'
        },
        justifyContent: 'flex-end',
        height: '100%',
        padding: '16px 24px'
    },
    button: {
        '&.MuiButton-root': {
            border: '1px solid #006AC3',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '40px',
            marginLeft: '10px',
            width: '104px'
        }
    },
    buttonContainer: {
        '@media screen and (max-width: 320px)': {
            paddingBottom: '20px',
            paddingTop: '24px'
        },
        backgroundColor: colors[mode].primaryBackground,
        height: '100%'
    },
    buttonSkip: {
        '&.MuiButton-root': {
            border: `1px solid ${colors[mode].primaryText}`,
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: colors[mode].primaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.46px',
            lineHeight: '16px',
            marginLeft: '10px',
            padding: '8px 16px',
            textTransform: 'uppercase',
            width: 'auto',
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)'
        }
    },
    buttonSubmit: {
        '&.MuiButton-root': {
            backgroundColor: '#FEDF01',
            border: '1px solid #FEDF01',
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#003168',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.46px',
            lineHeight: '16px',
            marginLeft: '10px',
            padding: '8px 16px',
            textTransform: 'uppercase',
            width: 'auto'
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
            opacity: '0.5'
        }
    },
    content: {
        fontSize: '24px',
        fontWeight: '500'
    },
    contentContainer: {
        borderRadius: '3px',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    contentDivider: {
        paddingTop: '25px'
    },
    contentSection: {
        fontSize: '20px'
    },
    deviceIconBox: {
        flexDirection: 'row',
        alignItems: 'center',
        display: 'flex',
        marginBottom: '8px'
    },
    deviceOption: {
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.9
        },
        alignItems: 'center',
        background: colors[mode].primaryBackground,
        border: `1px solid ${colors[mode].recoveryBorder}`,
        borderRadius: '2px',
        display: 'flex',
        flexDirection: 'row',
        fontFamily: 'Roboto',
        height: '60px',
        justifyContent: 'space-between',
        marginBottom: '16px',
        padding: '2px 12px',
        width: '90%'
    },
    deviceContainer: {
        flexDirection: 'column',
    },
    deviceOptionSelected: {
        background: colors[mode].skeletonInsightsBackground,
        border: `1px solid ${colors[mode].recoveryBorder}`,
        color: '#003168',
        fontFamily: 'Roboto',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
    },
    deviceTitle: {
        color: colors[mode].primaryText,
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Roboto',
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        marginLeft: '8px'
    },
    deviceTypeContainer: {
        '& > div': {
            paddingTop: '24px'
        }
    },
    divider: {
        background: '#FFC72A',
        padding: '2px',
        width: '50px'
    },
    download: {
        color: colors[mode].secondaryText,
        fontSize: '16px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '24px',
    },
    downloadContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        padding: '16px 35px'
    },
    downloadLink: {
        fontSize: '16px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '24px',
    },
    downloadVerbiageBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        paddingRight: '32px'
    },
    qrCodeWrapper: {
        backgroundColor: mode === 'dark' ? '#FFFFFF' : 'transparent',
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: mode === 'dark' ? '0 4px 12px rgba(0, 0, 0, 0.35)' : 'none'
    },
    formContainer: {
        flexDirection: 'column',
    },
    fieldsContainer: {
        backgroundColor: colors[mode].primaryBackground,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        padding: '16px 24px',
    },
    show: {
        display: 'block'
    },
    hide: {
        display: 'none'
    },
    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    radio: {
        '&.Mui-checked': {
            color: colors[mode].recoveryIcon
        },
        color: colors[mode].primaryText,
    },
    root: {
        padding: theme.spacing(0, 2, 2, 2)
    },
    italics: {
        fontStyle: 'italic'
    },
    warningLine: {
        background: colors[mode].primaryBackground,
        color: colors[mode].secondaryText,
        fontFamily: 'Roboto',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontSize: '14px',
        fontStyle: 'italic',
        fontWeight: 400,
        letterSpacing: '0.17px',
        lineHeight: '20px',
    }
    }
}
export default styles
